import { render, staticRenderFns } from "./RPLogin.vue?vue&type=template&id=08d3f6ac&style=width%3A%200%25%3B%20height%3A%200%25%3B"
import script from "./RPLogin.vue?vue&type=script&lang=js"
export * from "./RPLogin.vue?vue&type=script&lang=js"
import style0 from "./RPLogin.vue?vue&type=style&index=0&id=08d3f6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports